/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AppUserLookupQueryVariables = {
    query: string;
};
export type AppUserLookupQueryResponse = {
    readonly appuserLookup: {
        readonly intercomExternalUserId: string;
    } | null;
};
export type AppUserLookupQuery = {
    readonly response: AppUserLookupQueryResponse;
    readonly variables: AppUserLookupQueryVariables;
};



/*
query AppUserLookupQuery(
  $query: String!
) {
  appuserLookup(query: $query) {
    intercomExternalUserId
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intercomExternalUserId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppUserLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppUserNode",
        "kind": "LinkedField",
        "name": "appuserLookup",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppUserLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppUserNode",
        "kind": "LinkedField",
        "name": "appuserLookup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93b3439e47c1147ee9bfcffc4ec254c0",
    "id": null,
    "metadata": {},
    "name": "AppUserLookupQuery",
    "operationKind": "query",
    "text": "query AppUserLookupQuery(\n  $query: String!\n) {\n  appuserLookup(query: $query) {\n    intercomExternalUserId\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '9d267a6e3da641c727e233c052cb959a';
export default node;
